<template>
	<div class="online-only-badge" :class="{'large' : large == true}" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" v-if='tooltip != ""'>
		<div class="status-text">Exclusive<br>via<br>courier</div>
		<transition name="badge-tooltip-fade">
			<div class="badge-tooltip" v-if="is_hovered && tooltip">{{ tooltip }}</div>
		</transition>
	</div>
</template>

<script>
export default {
	props: ['tooltip', 'large'],
	data() {
		return {
			is_hovered: false
		}
	},
	methods: {
		handleMouseEnter() {
			this.is_hovered = true;
		},
		handleMouseLeave() {
			this.is_hovered = false;
		}
	}
}
</script>

<style scoped>
.online-only-badge {
	width: 80px;
	height: 80px;
	border: 1px solid #C84D0D;
	background-color: #C84D0D;
	border-radius: 50%;
	position: relative;
	font-size: 0.67rem;
	font-weight: 300;
	text-align: center;
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
}

.online-only-badge.large{
    width: 90px;
    height: 90px;
}

.badge-tooltip {
	position: absolute;
	top: calc(100% + 10px);
	left: 50%;
	transform: translateX(-50%);
	background-color: var(--maj-slate);
	color: #ffffff;
	font-size: 0.75rem;
	font-weight: 400;
	line-height: 1.4;
	white-space: nowrap;
	padding: 0.5rem 0.75rem;
	border-radius: 0.375rem;
	box-shadow: 0 0.375rem 1rem rgba(0, 0, 0, 0.18);
	z-index: 10;
}

.badge-tooltip::before {
	content: "";
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%);
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-bottom: 6px solid var(--maj-slate);
}

.badge-tooltip-fade-enter-active,
.badge-tooltip-fade-leave-active {
	transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}

.badge-tooltip-fade-enter-from,
.badge-tooltip-fade-leave-to {
	opacity: 0;
	transform: translateX(-50%) translateY(-6px);
}

.badge-tooltip-fade-enter-to,
.badge-tooltip-fade-leave-from {
	opacity: 1;
	transform: translateX(-50%) translateY(0);
}
</style>